export const fonts = {
  heading: 'Montserrat',
  body: 'Montserrat',
}
